module.exports = __webpack_public_path__ + "static/fonts/luengo-bold-webfont.418a72a5.woff";